import logo from './logo.svg'

export const theme = {
    color: {
      primary: "#F7B711",
      primaryHover: "#bf8800",
    },
    logoImage: logo,
    backend: "https://wlsb.epaper-publishing-one.de/",
    directory: "/kiosk",
    header: {
      title: "WLSB-Magazine",
      lineHeader: true
    },
    accToolbar: true,
    info: [
      {
      text: 'Impressum',
      link: 'https://www.wlsb.de/impressum'
    },
      {
      text: 'Datenschutz',
      link: 'https://www.wlsb.de/datenschutzerklaerung'
    },
  ],
  };